import React from "react";
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import "./main.css";

import IconImage from "../../images/Navbar Menu/Group location.png"
import Window from './../Window/index';
import Balconies from '../Balconies';
import GlazingCottages from './../Glazing of Cottages/index';
import Maintenance from './../Maintenance and Repair/index';
import Prices from './../Prices/index';
import Reviews from './../Reviews/index';
import Contacts from './../Contacts/index';

export default function Navbar() {
    return (
        <div className="container">
            <Router>
                <nav>
                    <div className="navbar-contact">
                        <h3 className="oknoprofi">
                            <span className="text-primary">ОКНО</span>ПРОФИ
                        </h3>
                        <div className="btn-group">
                            <div className="bnt-left">
                                <button>Калькулятор окон</button>
                            </div>
                            <div className="btn-right">
                                <button>Бесплатный замер</button>
                            </div>
                        </div>
                        <div className="location">
                            <div className="location-icon">
                                <img src={IconImage} alt="error" />
                            </div>
                            <div className="time-value">
                                <p>г. Челябинск, ул. <br /> Валдайская 25, оф.51</p>
                                <p>Пн-Сб с 9:00 до 18:00</p>
                            </div>
                        </div>
                        <div className="phone-url">
                            <p className="tell">
                                <a href="tel:+7 (800) 000-00-00" className="text-bark fs-4">+7 (800) 000-00-00</a>
                            </p>
                            <p className="zvanok">
                                <span>или </span><a href="#">закажите звонок</a>
                            </p>
                        </div>
                    </div>
                    <div className="navbar-menu">
                        <ul>
                            <li>
                                <NavLink to="/">Окна</NavLink>
                            </li>
                            <li>
                                <NavLink to="/balconies" >Остекление балконов</NavLink>
                            </li>
                            <li>
                                <NavLink to="/glazing" >Остекление коттеджей</NavLink>
                            </li>
                            <li>
                                <NavLink to="/maintenance" >Обслуживание и ремонт</NavLink>
                            </li>
                            <li>
                                <NavLink to="/prices" >Цены</NavLink>
                            </li>
                            <li>
                                <NavLink to="/rewiews" >Отзывы</NavLink>
                            </li>
                            <li>
                                <NavLink to="/contacts" >Контакты</NavLink>
                            </li>
                        </ul>
                    </div>
                </nav>
                <Routes>
                    <Route path="/" element={<Window />}></Route>
                    <Route path="/balconies" element={<Balconies />}></Route>
                    <Route path="/glazing" element={<GlazingCottages />}></Route>
                    <Route path="/maintenance" element={<Maintenance />}></Route>
                    <Route path="/prices" element={<Prices />}></Route>
                    <Route path="/rewiews" element={<Reviews />}></Route>
                    <Route path="/contacts" element={<Contacts />}></Route>
                </Routes>
                <nav>
                    <div className="navbar-contact">
                        <h3 className="oknoprofi">
                            <span className="text-primary">ОКНО</span>ПРОФИ
                        </h3>
                        <div className="btn-group">
                            <div className="bnt-left">
                                <button>Калькулятор окон</button>
                            </div>
                            <div className="btn-right">
                                <button>Бесплатный замер</button>
                            </div>
                        </div>
                        <div className="location">
                            <div className="location-icon">
                                <img src={IconImage} alt="error" />
                            </div>
                            <div className="time-value">
                                <p>г. Челябинск, ул. <br /> Валдайская 25, оф.51</p>
                                <p>Пн-Сб с 9:00 до 18:00</p>
                            </div>
                        </div>
                        <div className="phone-url">
                            <p className="tell">
                                <a href="tel:+7 (800) 000-00-00" className="text-bark fs-4">+7 (800) 000-00-00</a>
                            </p>
                            <p className="zvanok">
                                <span>или </span><a href="#">закажите звонок</a>
                            </p>
                        </div>
                    </div>
                </nav>
            </Router>
        </div>
    );
}
